module.exports = __webpack_public_path__ + "static/media/down_arrow.feef54e0.svg";